var dirty = (function($) {
	'use strict';

	var _hacksawJimDuggan = function() {
		$('section, [class^="col-"]').each(function(index, el) {
			var lastEl = $(" :not(:has(*))", this).last();
			var $lastEl = $(lastEl);
			
			$lastEl.css('margin-bottom', '0');

			if ($lastEl.parent('p')) {
				$lastEl.parent('p').css('margin-bottom', '0');
			}
		});
	};

	function init() {
		_hacksawJimDuggan();
	}

	return {
		init:init
	};
}(jQuery));

jQuery(document).ready(function($) {
	dirty.init();
});
